<template>
  <e-dialog
    :dialog-title="'所属分类'"
    :center-dialog-visible="classifyVisible"
    :popup-width="'500px'"
    :destroy-close="true"
    :modal-append-to-body="false"
    @updateVisible="classifyResetPopupData"
    @resetPopupData="classifyResetPopupData"
    @submitPopupData="classifySubmitPopupData"
  >
    <el-input v-model="filterText" placeholder="输入关键字进行过滤"></el-input>

    <div class="tree-box">
      <el-tree
        ref="tree"
        v-loading="loading"
        :data="categoryTreeData"
        show-checkbox
        highlight-current
        :props="defaultProps"
        :indent="30"
        :filter-node-method="filterTreeNode"
        :default-checked-keys="defaultCheckedKeys"
        :default-expanded-keys="defaultCheckedKeys"
        node-key="categoryId"
        check-strictly
        @check="handleCheck"
        @check-change="handleCheckChange"
      >
        <template slot-scope="{ node, data }">
          <div style="width: 100%; display: flex">
            <span>{{ data.categoryName }}</span>
          </div>
        </template>
      </el-tree>
    </div>
  </e-dialog>
</template>

<script>
import eDialog from '../../../../../components/common/epecDialog';

export default {
  name: 'ClassifyTree1',
  components: { eDialog },
  props: {
    classifyVisible: {
      type: Boolean,
      default: false,
    },
    defaultCheckedKeys: {
      type: Array,
      default() {
        return [];
      },
    },
    categoryTreeData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      filterText: '',
      loading: true,
      checkNodes: [],
      checkNodes2: [],
      categoryId: null,
      defaultProps: {
        label: 'categoryName',
        isLeaf: 'leafFlag',
        children: 'children',
      },
      checkFlag: false,
      checkCategoryIdList: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    categoryTreeData(val) {
      console.log(val);
      if (val.length) {
        this.loading = false;
      }
    },
  },
  methods: {
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.checkCategoryIdList = [];
      this.$emit('resetPopupData');
    },

    // 所属分类确定
    classifySubmitPopupData() {
      const arr = this.removeRepetition([
        ...this.checkNodes2,
        ...this.checkNodes,
      ]);
      this.checkNodes2 = [];
      this.checkNodes = [];
      console.log(arr, 'arr');

      console.log(this.$refs.tree.getCheckedNodes(), '树选中数据');
      this.$emit('submitPopupData', this.$refs.tree.getCheckedNodes());
    },

    // 去重
    removeRepetition(arr) {
      const obj = {};
      arr = arr.reduce(function (item, next) {
        obj[next.categoryId]
          ? ''
          : (obj[next.categoryId] = true && item.push(next));
        return item;
      }, []);
      return arr;
    },

    handleCheckChange(data, flag) {
      console.log(data, flag, 'handleCheckChange');
      if (flag) {
        this.checkNodes.push(data);
        this.checkNodes2.push(data);
      } else {
        this.checkNodes.forEach((item, index) => {
          if (item.categoryId == data.categoryId) {
            this.checkNodes.splice(index, 1);
          }
        });
        this.checkNodes2.forEach((item, index) => {
          if (item.categoryId == data.categoryId) {
            this.checkNodes.splice(index, 1);
          }
        });

        console.log(this.checkNodes, this.checkNodes2);
      }

      console.log(this.checkNodes, this.checkNodes2, 'handleCheckChange');
    },

    // 勾选树节点
    async handleCheck(data, nodes) {
      console.log(data, nodes, 'handleCheck');
      this.checkNodes2 = nodes.checkedNodes.filter((item) => item.leafFlag);
      if (!this.checkCategoryIdList.includes(data.categoryId)) {
        this.checkFlag = true;
        this.checkCategoryIdList.push(data.categoryId);
        const node = this.$refs.tree.getNode(data.categoryId);
        // 设置未进行的懒加载状态
        node.loaded = false;
        // 重新展开节点就会间接出发load达到刷新效果
        node.expand();
      }
    },

    filterTreeNode(value, data) {
      if (!value) return true;
      return data.categoryName.indexOf(value) !== -1;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  padding: 20px;
}
::v-deep .el-dialog__body {
  height: 312px;
  overflow-y: auto;
  padding-bottom: 0;
}
.tree-box {
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  padding: 2px 0;
  overflow-y: auto;
  margin-top: 10px;
}
</style>
